import React from 'react';

const useFirebaseDatabaseQuery = (ref) => {
  const [docState, setDocState] = React.useState({
    isLoading: true,
    data: null,
  });

  React.useEffect(() => ref.on('value', (snapshot) => {
    setDocState({
      isLoading: false,
      data: snapshot?.val() || {},
    });
    // eslint-disable-next-line
  }), []);

  return docState;
};

export default useFirebaseDatabaseQuery;
